import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';

type EditFormNavigationProps = {
  onCancel: () => void;
  saving: boolean;
  disabled?: boolean;
};

const EditFormNavigation = ({
  onCancel,
  saving,
  disabled = false,
}: EditFormNavigationProps) => {
  const { t } = useTranslation();
  return (
    <>
      <Divider />
      <Grid
        container
        sx={{
          justifyContent: 'space-between',
          '&&': { mt: 0 },
        }}
      >
        <Button variant="outlined" color="primary" onClick={onCancel}>
          {t('ui.event-management.cancel')}
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={disabled}
          endIcon={
            saving && (
              <CircularProgress
                size={24}
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  marginTop: '-12px',
                  marginLeft: '-12px',
                }}
              />
            )
          }
        >
          {t('ui.event-management.events.edit.save-event')}
        </Button>
      </Grid>
    </>
  );
};

export default EditFormNavigation;
